import React, { memo } from 'react'

/**
 * INPUT COMPONENT
 * @param {{ type: string, name: string, placeholder: string, invalidMessage: string }} props 
 * @returns {JSX.Element}
 */
function Input({ type = 'text', name, placeholder, invalidMessage, ...props}) {
  return (
    <>
      <input type={type} name={name} id={name} className="input-control peer cursor-text" placeholder={placeholder} {...props} focus='false' />
      <p className="mt-1 invisible peer-invalid:visible text-red-500 text-sm hidden">
        {invalidMessage}
      </p>
    </>
    
  )
}

export default memo(Input)